import Progress from "components/Progress";
import React, { FC, ReactNode } from "react";

interface TableProps<T> {
  headings?: ReactNode[];
  rowsData: T[];
  rows?: ReactNode[][];
  isLoading?: boolean;
  className?: string;
  headClassName?: string;
  bodyClassName?: string;
  selectedRow?: number;
  onRowClick?: (i: number) => void;
  trHeadingClassName?: string;
}

const Table = <T,>({
  headings,
  rowsData,
  rows,
  isLoading,
  className = "",
  headClassName = "",
  bodyClassName = "",
  selectedRow,
  trHeadingClassName = "",
  onRowClick,
}: TableProps<T>) => {
  return (
    <table className={`rounded ${className ? className : ""}`}>
      {headings && (
        <thead className={headClassName}>
          <tr
            className={`${trHeadingClassName} border-b-[1px] border-themed-border`}
          >
            {headings.map((heading, i) => (
              <th className="px-5 py-[10px] text-left" key={i}>
                {heading}
              </th>
            ))}
          </tr>
        </thead>
      )}

      {rows && (
        <tbody className={`relative ${bodyClassName}`}>
          {isLoading && (
            <tr>
              <td colSpan={headings?.length ?? 1}>
                <div className="w-full h-[60vh] flex items-center justify-center bg-themed-card bg-opacity-75">
                  <Progress />
                </div>
              </td>
            </tr>
          )}
          {!isLoading &&
            rows.map((row, i) => (
              <tr
                key={i}
                className={`border-b-[1px] border-themed-border hover:bg-themed-background ${
                  onRowClick ? "cursor-pointer" : ""
                } ${
                  i === selectedRow
                    ? "!bg-[#6366F1] !text-themed-background selected-row"
                    : ""
                }`}
                onClick={() => onRowClick?.(i)}
              >
                {row.map((el, j) => (
                  <td className="px-5 py-[10px]" key={j}>
                    {el}
                  </td>
                ))}
              </tr>
            ))}
        </tbody>
      )}
    </table>
  );
};

export default Table;
